import { motion } from 'framer-motion'
import React, { useEffect, useRef, useState } from 'react'
import ReactGA from 'react-ga'
import { IoIosArrowDown } from 'react-icons/io'
import ym from 'react-yandex-metrika'

import { getAnimationFourParams } from '../../../helpers/animations'
import { pluralize } from '../../../helpers/common'
import { useProjects } from '../../../hooks/useProjects'
import { fetchCitiesRequest } from '../../../store/cities/actions'
import { fetchObjectsRequest } from '../../../store/objects/actions'
import { NewProjectCard } from '../../NewProjectCard/NewProjectCard'
import { NewRoomsFilter } from '../../UI/NewRoomsFilter/NewRoomsFilter'
import { PlacesMap } from '../../UI/PlaceMap/PlacesMap'
import styles from './newBuildings.module.scss'
import { ProjectsData } from './NewBuildings.types'

export const NewBuildings = () => {
  const {
    items,
    cities: { items: citiesItems },
    showMore,
    setShowMore,
    openCitiesBlock,
    handleOpenCitiesBlock,
    getCity,
    handleOpenCity,
    getRooms,
    handleOPenAll,
    dispatch,
    setGetRooms,
    rangeValue,
    projectsData,
    declineCity,
    result,
    setResult,
    ready,
    setReady,
    deadline,
    handleSelect,
    setRangeValue,
  } = useProjects()

  const filterRef = useRef<HTMLDivElement>(null)

  const [mapState, setMapState] = useState(true)
  const handleCloseSix = () => {
    if (showMore !== 6) {
      setShowMore(6)
    }
    filterRef.current?.scrollIntoView()
    ReactGA.ga('send', 'event', 'main', 'projects bottom list', 'hide')
    ym('reachGoal', 'projects list click', {
      'projects list click': {
        bottom: {
          'click type': 'hide',
        },
      },
    })
  }

  const handleToggleMap = () => {
    setMapState(!mapState)
  }

  const filterAnalytics = (value: string) => {
    {
      ReactGA.ga('send', 'event', 'main', 'filters click', value)
    }
    ym('reachGoal', 'filters click', {
      'filters click': {
        main: {
          'filters name': value,
        },
      },
    })
  }

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value }: any = event.target
    setGetRooms((prevValues: string[]) => {
      if (prevValues.includes(value)) {
        return prevValues.filter(val => val !== value)
      }

      return [...prevValues, value]
    })
    filterAnalytics(value)
  }

  const handleStateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value }: any = event.target
    setReady((prevState: string) => {
      if (prevState === 'now') {
        return ''
      } else {
        return value
      }
    })
    filterAnalytics(value)
  }

  const handleRenovationChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value }: any = event.target
    setResult((prevState: string) => {
      if (prevState === 'ready') {
        return ''
      } else {
        return value
      }
    })
    filterAnalytics(value)
  }

  useEffect(() => {
    const filters = {
      city: getCity,
      rooms: getRooms.join('-or-'),
      priceFrom: String(rangeValue[0]).split(' ').join(''),
      priceTo: String(rangeValue[1]).split(' ').join(''),
      date: deadline,
      state: ready,
      renovation: result,
    }
    dispatch(fetchObjectsRequest(filters))
    dispatch(fetchCitiesRequest())
  }, [getCity, getRooms, ready, result, deadline, rangeValue])

  return (
    <motion.div {...getAnimationFourParams}>
      <section className='section' id='#newBuildings'>
        <div className={`d-if ai-c relative fwr-wr ${styles.titles}`}>
          <h2 className='section__title'>Новостройки</h2>
          <h2
            className={['section__title', styles.cityTitle].join(' ')}
            onClick={handleOpenCitiesBlock}
          >
            в {declineCity(getCity)}
            <IoIosArrowDown />
          </h2>
          {openCitiesBlock && (
            <div className={styles.citiesBlock}>
              {citiesItems?.map((item: string) => (
                <p
                  className={item === getCity && styles.activeCity}
                  onClick={() => handleOpenCity(item)}
                >
                  {declineCity(item)}
                </p>
              ))}
            </div>
          )}
        </div>

        <div
          ref={filterRef}
          className={`d-f-d ai-c jc-sb ${styles.filterBlock}`}
        >
          <NewRoomsFilter
            map={mapState}
            toggleMap={handleToggleMap}
            roomsChange={handleCheckboxChange}
            renovationChange={handleRenovationChange}
            stateChange={handleStateChange}
            deadlineChange={handleSelect}
            selectedDeadline={deadline}
            setRangeValue={setRangeValue}
            rangeValue={rangeValue}
          />
          <div className={`btn no-hover ${styles.projectCounter}`}>
            <span>
              {items?.length > 0 &&
                pluralize(
                  items?.length as number,
                  'Подобран',
                  'Подобрано',
                  'Подобрано',
                  true
                )}{' '}
              {items?.length > 0
                ? pluralize(
                    items?.length as number,
                    'проект',
                    'проекта',
                    'проектов'
                  )
                : 'нет проектов'}
            </span>
          </div>
        </div>

        <PlacesMap mapState={mapState} city={getCity} />

        <div
          className={`NewCards ${styles.projectsList} ${
            mapState ? 'is-hidden' : ''
          }`}
          id='cardsBlock'
        >
          <div className='new-cards__items NewCards__items--3'>
            {projectsData?.slice(0, showMore).map((item: ProjectsData) => {
              return (
                <div key={item.UF_BUILDING_NAME}>
                  <NewProjectCard data={item} />
                </div>
              )
            })}
          </div>
          {items?.length > 6 && (
            <div className='new-cards__btn'>
              <button
                className='btn btn--gray'
                onClick={() => {
                  if (showMore < items?.length) {
                    handleOPenAll()
                  } else {
                    handleCloseSix()
                  }
                }}
              >
                {showMore < items?.length ? 'Показать ещё' : 'Скрыть все'}
              </button>
            </div>
          )}
        </div>
      </section>
    </motion.div>
  )
}
